import { useLoaderData } from "react-router-dom";
import SaleBanners from "src/components/features/home/SaleBanners/SaleBanners";
import TopDestinations from "src/components/features/home/TopDestinations/TopDestinations";
import SearchForm from "src/components/features/search/SearchForm/SearchForm";
import { useDeviceContext } from "src/context/device-context";
import useLoginPopup from "src/hooks/useLoginPopup";
import { FlightBookingGuide } from "../components/features/home/FlightBookingGuide/FlightBookingGuide";
import { CheapDestinations } from "../components/features/home/CheapDestinations/CheapDestinations";

const TEMP_ALLOWED_COMPANIES = ["celotleti"];

function HomePage() {
  const { isMobile } = useDeviceContext();
  const { bookingGuide, topDestinations, saleBanners, cheapDestinations } = useLoaderData();
  useLoginPopup();

  return (
    <main id="tickets-home-page" className={isMobile ? "mobile" : "desktop"}>
      <div className="home-content white">
        <SearchForm />
        <SaleBanners saleData={saleBanners.data} />
        <TopDestinations travelDeals={topDestinations.data} />
      </div>
      <div className="home-content off-white">
        <CheapDestinations data={cheapDestinations.data} />
        {!bookingGuide.error &&
          TEMP_ALLOWED_COMPANIES.includes(window.SERVER_DATA.REACT_APP_TENANT_NAME) && (
            <FlightBookingGuide data={bookingGuide.data} />
          )}
      </div>
    </main>
  );
}

export default HomePage;
